import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as CloseSVG } from "assets/icons/exit.svg";
import { useSession } from 'hooks';
import useResponsive from 'utils/hooks/useResponsive';
import useModal from 'hooks/useModal';
import {
  Text,
  Input,
  Button,
  TextLink,
  Div
} from 'ui';
import useSnackbar from 'hooks/useSnackbar';
import ModalTemplate from '../components/ModalTemplate';
import { ReactComponent as ErrorSVG } from 'assets/icons/snackbar/error.svg'


const Login = () => {

  const { t } = useTranslation()

  const { isMobile } = useResponsive()
  const { Modal } = useModal()
  const { Modal: ModalWelcome } = useModal('welcome')
  const { Modal: ModalRecovery } = useModal('recovery')
  const { Modal: ModalRegister } = useModal('register')

  const { Snackbar } = useSnackbar('error')

  const {
    login,
    loginError,
    isLogging,
    isLoggedIn,
  } = useSession()

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const handleLogin = (e) => {
    e.preventDefault()

    login({
      email: username,
      password
    })
  }

  const openRecoveryModal = () => ModalRecovery.open()


  useEffect(() => {
    if (isLoggedIn) Modal.close()
  }, [isLoggedIn])

  useEffect(() => {
    if (loginError) Snackbar.open({
      icon: ErrorSVG,
      message: t('wrongCredentials')
    })
  }, [loginError])


  return (
    <ModalTemplate onBack={ModalWelcome.open}>
      <Text
        as='h1'
        size={isMobile ? 'xl' : '3xl'}
        color='headline'
      >
        {t('login')}
      </Text>

      <Div marginTop={16} marginBottom={32}>
        <Text size={isMobile ? 'sm' : 'base'} align='center'>
          {t('goodToSeeYouAgain')}
        </Text>
        <Text size={isMobile ? 'sm' : 'base'} align='center'>
          {t('fillInYourDetails')}
        </Text>
      </Div>

      <Div
        as='form'
        display='flex'
        flexDirection='column'
        onSubmit={handleLogin}
        height='100%'
        width='100%'
        textAlign='center'
      >
        <Div display='flex' flexDirection='column' gap={16}>
          <Input.Text
            label={t('usernameOrEmail')}
            value={username}
            onChange={setUsername}
          />
          <Input.Password
            label={t('password')}
            value={password}
            onChange={setPassword}
            iconRight={CloseSVG}
          />
        </Div>

        <Div marginTop={10} marginBottom={10}>
          <Text as='span' size='xs'>
            {t('recaptchaStatement_1')}
          </Text>
          {' '}
          <Text as='span' size='xs' color='headline'>
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer" 
            >
              {t('recaptchaStatement_2')}
            </a>
          </Text>
          {' '}
          <Text as='span' size='xs'>
            {t('recaptchaStatement_3')}
          </Text>
          {' '}
          <Text as='span' size='xs' color='headline'>
            <a
              href="https://policies.google.com/terms"
              target="_blank"
              rel="noopener noreferrer" 
            >
              {t('recaptchaStatement_4')}
            </a>
          </Text>
          {' '}
          <Text as='span' size='xs'>
            {t('recaptchaStatement_5')}
          </Text>
        </Div>

        <Div
          marginTop={12}
          marginBottom={isMobile ? 148 : 82}
        >
          <TextLink size='xs' onClick={openRecoveryModal}>
            {t('forgotMyPassword')}
          </TextLink>
        </Div>

        <Button
          size='large'
          isFull
          disabled={!username || !password}
          isLoading={isLogging}
        >
          {isLogging
            ? t('loggingIn')
            : t('login')
          }
        </Button>

        <Div marginTop={16}>
          <Text as='span' size='xs'>
            {t('firstTimeInFlixxo')}
          </Text>
          {' '}
          <TextLink size='xs' isInline onClick={ModalRegister.open}>
            {t('createYourAccount')}
          </TextLink>
        </Div>
      </Div>

    </ModalTemplate>
  )

}

export default Login